import type { RouteStatus } from '@xingroute/schema'

// Trail polyline colour, single source for Mapbox Static Images API and the
// interactive `RouteMap` fallback (when grade data is missing). The Mapbox
// Static API URL can't read CSS variables, so these are kept as stable hex
// literals that mirror the `--xr-*` tokens documented in
// `wiki/decisions/06-design-system.md` §Trail colour policy:
//
//   published / archived / unknown → Accent Twilight (live / active trail)
//   draft / unpublished            → neutral muted grey (not-yet-live)
//
// Brand Moss is reserved for UI chrome + start dot + waypoint markers so the
// trail / chrome stay visually opposed ("active orange" vs "safe green") on
// interactive maps. EXCEPTION: list-card thumbnails (no markers rendered) use
// `trailColorForThumbnail` → Brand Moss green; see that helper below.
export const TRAIL_COLOR_PUBLISHED = '#e66725' // --xr-accent-fill
export const TRAIL_COLOR_DRAFT = '#6b7280' // --xr-text-muted (neutral grey)

// Thumbnail-only published trail colour: Brand Moss / logo green. List-card
// thumbnails render just the route polyline over a clean data-viz basemap
// (light/dark v11) with NO start dot or waypoint markers, so the trail can use
// green without colliding with the green chrome markers that the §Trail colour
// policy reserves green for on *interactive* maps. Detail-page `RouteMap`
// polyline + editor drawing keep Accent Twilight because they DO sit next to
// green markers. See wiki/decisions/06-design-system.md §Trail colour policy.
export const TRAIL_COLOR_THUMBNAIL_PUBLISHED = '#1a5a44' // --xr-brand-primary (logo green)

// Thumbnail variant: published routes get logo green, drafts stay neutral grey.
export function trailColorForThumbnail(status: RouteStatus | null | undefined): string {
  return status === 'draft' || status === 'pending_review'
    ? TRAIL_COLOR_DRAFT
    : TRAIL_COLOR_THUMBNAIL_PUBLISHED
}
